import lodash from 'lodash';
import SocketIO from 'socket.io-client';
import { getAppConfig } from 'common/util/configUtil';
import uuid from 'node-uuid';

export class Socket {
    constructor() {
        this.socket;
    }

    buildSocketOpts(path) {
        return lodash.isEmpty(path) ? {} : { path };
    }

    initSocket({ sub, accessToken }) {
        const { socketUrl, socketPath } = getAppConfig();
        const socketOpts = this.buildSocketOpts(socketPath);
        lodash.set(socketOpts, 'query.sub', sub);
        lodash.set(socketOpts, 'auth.token', accessToken);

        this.socket = SocketIO(socketUrl, socketOpts);
    }

    checkSession({ sub, accessToken }) {
        const requestId = uuid.v4();
        this.socket.emit('checkSession', {
            requestId,
            sub,
            accessToken
        });

        return new Promise(resolve => {
            this.socket.once(`checkSession/${requestId}`, message => {
                const { sessionExists } = message;
                resolve(sessionExists);
            });
        });
    }

    async subscribeToChannel(channel, func) {
        this.socket.on(`${channel}`, func);
    }

    async publishToChannel(channel, data) {
        this.socket.emit(`${channel}`, data);
    }
}